// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"150":"3fc990d8","243":"85e62a48"}[chunkId] + ".chunk.css";
};